import React, { useState, useRef, useEffect } from "react";
import "./AdminShared.css";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

const AddCertificate = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    description: "",
    gst: "",
    days: "",
    aboutCourse: "",
    eligibility: "",
    courseIncludes: "",
    courseExcludes: "",
    mainImage: null,
    galleryImages: [],
  });

  const [submitting, setSubmitting] = useState(false);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("adminInfo");
    if (!token) {
      navigate("/admin");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "mainImage" && files?.length) {
      setFormData((p) => ({ ...p, mainImage: files[0] }));
      setPreview(URL.createObjectURL(files[0]));
    } else if (name === "galleryImages") {
      setFormData((p) => ({ ...p, galleryImages: Array.from(files) }));
    } else {
      setFormData((p) => ({ ...p, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (!value) return;
      if (key === "galleryImages") {
        value.forEach((img) => data.append("galleryImages", img));
      } else {
        data.append(key, value);
      }
    });

    try {
      const res = await fetch(`${API_BASE_URL}/api/certificates`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("adminInfo"))?.token}`,
        },
        body: data,
      });

      if (!res.ok) throw new Error("Failed");

      alert("✅ Certificate added successfully");
      navigate("/admin/certificates");
    } catch (err) {
      alert("❌ Upload failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button
            className="admin-back-btn"
            onClick={() => navigate("/admin/panel")}
            title="Back to Command Center"
          >
            ←
          </button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Create Resource</h1>
        </div>
        <div className="module-badge" style={{ background: '#d946ef' }}>New Certificate</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-form-card">
          <form className="admin-form-elite" onSubmit={handleSubmit}>
            <label>
              Certificate Name
              <input name="name" value={formData.name} onChange={handleChange} placeholder="Enter full name" required />
            </label>

            <label>
              Price (INR)
              <input type="number" name="price" value={formData.price} onChange={handleChange} placeholder="0.00" required />
            </label>

            <label className="full-width-field">
              Short Description
              <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Brief summary for list view..." required />
            </label>

            <label>
              GST Details
              <input name="gst" value={formData.gst} onChange={handleChange} placeholder="e.g. 18% Exclusive" required />
            </label>

            <label>
              Duration (Days)
              <input type="number" name="days" value={formData.days} onChange={handleChange} placeholder="Number of days" required />
            </label>

            <label className="full-width-field">
              About Course
              <textarea name="aboutCourse" value={formData.aboutCourse} onChange={handleChange} placeholder="In-depth details..." required />
            </label>

            <label className="full-width-field">
              Eligibility Criteria
              <textarea name="eligibility" value={formData.eligibility} onChange={handleChange} placeholder="Requirements to join..." required />
            </label>

            <label>
              What's Included
              <textarea name="courseIncludes" value={formData.courseIncludes} onChange={handleChange} placeholder="Features, kits, etc." required />
            </label>

            <label>
              What's Excluded
              <textarea name="courseExcludes" value={formData.courseExcludes} onChange={handleChange} placeholder="Extra costs..." required />
            </label>

            <label>
              Primary Asset (Image)
              <input ref={fileInputRef} type="file" name="mainImage" accept="image/*" onChange={handleChange}  />
            </label>

            <label>
              Gallery Roll (max 4)
              <input type="file" name="galleryImages" accept="image/*" multiple onChange={handleChange} />
            </label>

            {preview && (
              <div className="img-preview-box">
                <img src={preview} alt="preview" className="preview-thumb" />
              </div>
            )}

            <div className="admin-submit-area">
              <button className="btn-primary-elite" disabled={submitting}>
                {submitting ? "Initializing..." : "Register Certificate"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCertificate;
